export * from './ArrowDim2DiagMinRightIcon';
export * from './ArrowDim2DiagMinRightIcon16Light';
export * from './ArrowDim2DiagMinRightIcon16Regular';
export * from './ArrowDim2DiagMinRightIcon16Solid';
export * from './ArrowDim2DiagMinRightIcon20Light';
export * from './ArrowDim2DiagMinRightIcon20Regular';
export * from './ArrowDim2DiagMinRightIcon20Solid';
export * from './ArrowDim2DiagMinRightIcon24Regular';
export * from './ArrowDim2DiagMinRightIcon24Solid';
export * from './ArrowDim2DiagMinRightIcon32Regular';
export * from './ArrowDim2DiagMinRightIcon64Regular';
